<div class="featured-coupons-wrapper mb-2">
    <h4>Featured Coupons</h4>
    <ng-container *ngIf="(visibleCouponsWithEligibility$ | async) as couponsDisplay; else noAvailableCoupons">
        <ng-container *ngIf="couponsDisplay.length > 0; else noAvailableCoupons">
            <div class="featured-coupons-list">
                <div *ngFor="let couponItem of couponsDisplay" class="featured-coupon-card rounded-1 bg-white p-2"
                    [ngClass]="{
            'coupon-applied': cartService.isCouponActive(couponItem.coupon.coupon_code),
            'coupon-ineligible': !couponItem.isEligible
          }">
                    <div class="featured-coupon-top">
                        <div class="featured-coupon-icon">
                            <i class="fa-solid fa-percent"></i>
                        </div>
                        <div class="featured-coupon-details">
                            <div class="featured-coupon-saving">
                                <ng-container
                                    *ngIf="cartService.isCouponActive(couponItem.coupon.coupon_code); else showSavedText">
                                    Saved {{ couponItem.coupon.discount_type === 'percentage'
                                    ? couponItem.coupon.discount_value + '%'
                                    : (couponItem.coupon.discount_value | currency:'INR':'symbol':'1.0-0') }}!
                                </ng-container>

                                <ng-template #showSavedText>
                                    <ng-container
                                        *ngIf="couponItem.coupon.discount_type === 'percentage'; else fixedSaving">
                                        Get {{ couponItem.coupon.discount_value }}% OFF!
                                    </ng-container>
                                    <ng-template #fixedSaving>
                                        Save {{ couponItem.coupon.discount_value | currency:'INR':'symbol':'1.0-0' }}!
                                    </ng-template>
                                </ng-template>
                            </div>
                            <div class="featured-coupon-description">
                                <ng-container
                                    *ngIf="couponItem.coupon.discount_type === 'percentage'; else fixedDescription">
                                    {{ couponItem.coupon.display_text }}
                                </ng-container>

                                <ng-template #fixedDescription>

                                    <ng-container
                                        *ngIf="couponItem.coupon.min_order_value && couponItem.coupon.min_order_value > 0; else noMinimumOrder">
                                        Flat {{ couponItem.coupon.discount_value | currency:'INR':'symbol':'1.0-0' }}
                                        OFF on orders above {{ couponItem.coupon.min_order_value |
                                        currency:'INR':'symbol':'1.0-0' }}
                                    </ng-container>

                                    <ng-template #noMinimumOrder>
                                        Flat {{ couponItem.coupon.discount_value | currency:'INR':'symbol':'1.0-0' }}
                                        OFF
                                    </ng-template>
                                </ng-template>
                            </div>
                        </div>
                        <div class="featured-coupon-action">
                            <button type="button" class="featured-coupon-action-btn" [disabled]="!couponItem.isEligible"
                                [ngClass]="{
                  'remove': cartService.isCouponActive(couponItem.coupon.coupon_code),
                  'disabled': !couponItem.isEligible
                }" (click)="onApplyOrRemoveCoupon(couponItem.coupon.coupon_code, couponItem.isEligible)">

                                <ng-container
                                    *ngIf="cartService.isCouponActive(couponItem.coupon.coupon_code); else showApply">
                                    Remove
                                </ng-container>

                                <ng-template #showApply>
                                    <ng-container *ngIf="couponItem.isEligible; else showIneligible">
                                        Apply
                                    </ng-container>
                                    <ng-template #showIneligible>
                                        Ineligible
                                    </ng-template>
                                </ng-template>

                            </button>
                        </div>
                    </div>
                    <div class="featured-coupon-divider"></div>
                    <div class="featured-coupon-bottom">
                        <div class="featured-coupon-code">
                            {{ couponItem.coupon.coupon_code }}
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </ng-container>
    <ng-template #noAvailableCoupons>
        <div class="featured-coupon-empty">
            <div class="featured-coupon-empty-icon">
                <i class="fa-solid fa-percent"></i>
            </div>
            <div>
                <div class="featured-coupon-empty-title">
                    No coupons available
                </div>
                <div class="featured-coupon-empty-text">
                    No special coupons available for you right now.
                </div>
            </div>
        </div>
    </ng-template>
</div>